import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalService } from '@nx-ratenow/core/data-access-local-storage';
import { Observable } from 'rxjs';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private localStorageSvc: LocalService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let newHeaders = req.headers;

    if (typeof req.body === 'string' && req.body?.includes('refresh_token')) {
      return next.handle(req);
    }

    if (this.localStorageSvc.getData('oauthInfo')) {
      const storageOauthInfo = JSON.parse(this.localStorageSvc.getData('oauthInfo'));
      if (storageOauthInfo && storageOauthInfo?.access_token) {
        if (storageOauthInfo?.access_token) {
          if (!req.headers.has('Authorization')) {
            newHeaders = newHeaders.append('Authorization', `${storageOauthInfo.token_type} ${storageOauthInfo.access_token}`);
          }

          if (req.url.includes('avatar')) {
            return next.handle(req.clone({ headers: newHeaders }));
          }

          if (req.url.includes('image') && req.method === 'GET') {
            newHeaders = newHeaders.append('Content-Type', 'image/png');
            return next.handle(req.clone({ headers: newHeaders }));
          }

          // if (req.url.includes('file') && req.method === 'POST') {
          //   newHeaders = newHeaders.append(
          //     'Content-Type',
          //     'multipart/form-data'
          //   );
          //   return next.handle(req.clone({ headers: newHeaders }));
          // }
        }
        // newHeaders = newHeaders.append(
        //   'Content-Type',
        //   'application/json; charset= UTF-8'
        // );
      }
      return next.handle(req.clone({ headers: newHeaders }));
    }
    return next.handle(req.clone({ headers: newHeaders }));
  }
}
